/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/user/UserController',[
        'modules/module',
        'settings',
        'modules/basemodule/controllers/EntityListController'
    ],
    function (module) {
        'use strict';
        module.controller('UserController', ['$scope', '$controller', 'BASE_TEMPLATES_PATH',
            function ($scope, $controller, BASE_TEMPLATES_PATH) {

            angular.extend(this, $controller('EntityListController', {
                $scope: $scope
            }));

            $scope.tableOptions.fields = [
                {
                    id: 'USERNAME',
                    heading:    'Benutzername',
                    attribute:  'username'
                },
                {
                    id: 'FIRST_NAME',
                    heading:    'Vorname',
                    attribute:  'firstName'
                },
                {
                    id: 'LAST_NAME',
                    heading:    'Nachname',
                    attribute:  'lastName'
                },
                {
                    id: 'EMAIL',
                    heading:    'E-Mail',
                    attribute:  'email'
                },
                {
                    id: 'ROLES',
                    heading:    'Rollen',
                    template:    BASE_TEMPLATES_PATH + '/settings/user/user-roles-col.html',
                    searchDisabled: true,
                    orderDisabled: true
                }
            ];
            $scope.formState = 'root.user';

            $scope.init('User');
        }]);
    }
);



